import axios from './index'

export default {
  list(params) {
    return axios.get('/api/v1/employee/tip', { params })
  },
  group(params) {
    return axios.get('/api/v1/employee/tip/group', { params })
  },
}